module.exports = __webpack_public_path__ + "img/barasalades.b5c048d0.png";